@if (
  {
    company: company()
  };
  as STATE
) {
  <section class="company-success-card">
    <article class="company-success-card__header">
      <h2>Résultats de la vérification du NCC</h2>
      <p>
        Les informations et le statut de cette entreprise sont affichées
        ci-dessous.
      </p>
    </article>
    <article class="company-success-card__body">
      <table>
        <tbody>
          <tr>
            <td>NCC</td>
            <td class="text-right">{{ STATE.company?.nif }}</td>
          </tr>
          <tr>
            <td>Nom ou raison sociale</td>
            <td class="text-right">{{ STATE.company?.name }}</td>
          </tr>
          <tr>
            <td>Régime d’imposition</td>
            <td class="text-right">{{ STATE.company?.taxSystem ?? '-' }}</td>
          </tr>
        </tbody>
      </table>
    </article>
    <article class="company-registration-card">
      <h1 class="company-registration-card__title">
        Entreprise inscrite à la FNE
      </h1>

      <p class="company-registration-card__date">
        <span class="label">Date d'inscription :</span>
        <span class="value">
          {{ (STATE.company?.createdAt | date: 'dd/MM/yyyy') || '-' }}
        </span>
      </p>
    </article>
  </section>
}
